import React from 'react';
import * as S from './hooks.styles';
import * as Yup from 'yup';
import { DateInputField, errorMessages, SelectField } from '../../../ui/formik-controls';
import { FormFieldsFunction } from './form-fields';
import { CardsInterface } from '../api/report-types';
import * as _ from 'lodash';
import { usePartnerList } from '../../../../api/partner-hooks';
import moment from 'moment';

const state: Partial<CardsInterface> = {
  partnerMnemocode: undefined,
  period: undefined,
};

const schema: Yup.Schema<object | undefined> = Yup.object().shape({
  partnerMnemocode: Yup.string().required(errorMessages.required),
  period: Yup.string().required(errorMessages.required),
});

export const useCards: FormFieldsFunction<Partial<CardsInterface>> = () => {
  const partnerMnemocodeOptions = _.chain(usePartnerList())
    .get('data')
    .map((partner) => ({ value: partner?.mnemocode, caption: `${partner?.mnemocode} - ${partner?.components?.name}` }))
    .value();

  function render() {
    return (
      <S.FormWrapper>
        <S.Column>
          <SelectField
            options={partnerMnemocodeOptions}
            name="partnerMnemocode"
            label="Партнер"
            filterable={false}
            placeholder="Выберите партнера"
          />
          <DateInputField
            name="period"
            label="Период"
            placeholder="YYYY-MM"
            formatDate={(date) => moment(date).format('YYYY-MM')}
            parseDate={(str) => moment(str, 'YYYY-MM').toDate()}
          />
        </S.Column>
      </S.FormWrapper>
    );
  }

  return {
    state,
    schema,
    render,
  };
};
